// Generated by purs version 0.14.4
var RLProxy = (function () {
    function RLProxy() {

    };
    RLProxy.value = new RLProxy();
    return RLProxy;
})();
export {
    RLProxy
};
//# sourceMappingURL=index.js.map
